import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NbpInfoComponent, UtilHelper } from '../../../shared';
import { ConsumidorModel, ConsumidorService } from '../shared/';
import { LoginService } from '../shared/login.service';

@Component({
  selector: 'app-consumidor-descadastrar',
  templateUrl: './consumidor-descadastrar.component.html',
  styleUrls: []
})
export class ConsumidorDescadastrarComponent implements OnInit {
  public consumidor: ConsumidorModel = new ConsumidorModel();
  public cpfFormat = '';

  constructor(
    private readonly consumidorService: ConsumidorService,
    private readonly router: Router,
    private readonly ngbModalService: NgbModal,
    private readonly loginService: LoginService
  ) {}

  ngOnInit() {
    this.consumidor = this.consumidorService.getConsumidorModel();

    this.loginService.logout();
    this.consumidorService.setEditMode(false);
    this.cpfFormat = `${UtilHelper.lpad(this.consumidor.cpfBase.toString(), 9)}${UtilHelper.lpad(
      this.consumidor.cpfDigito.toString(),
      2
    )}`;

    if (!this.consumidor.cpfBase || !this.consumidor.dataExclusao) {
      const confirmModal = this.ngbModalService.open(NbpInfoComponent);
      confirmModal.componentInstance.info = 'Cidadão não encontrado!';
      this.router.navigate(['/consumidor']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-descadastrar/consumidor-descadastrar.component.ts